import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=b2a2fa9e"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=b2a2fa9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports